import * as React from 'react';
export var TickCircle = function TickCircle(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
    points: "19.9,31.9 21.4,33.4 36.1,18.6 33.2,15.7 21.4,27.5 15.5,21.6 12.5,24.5 18.4,30.4"
  })), React.createElement("path", {
    d: "M24,4.2c10.9,0,19.8,8.9,19.8,19.8S34.9,43.8,24,43.8S4.2,34.9,4.2,24S13.1,4.2,24,4.2 M24,0C10.7,0,0,10.7,0,24\n      s10.7,24,24,24s24-10.7,24-24S37.3,0,24,0L24,0z"
  })));
};